// extracted by mini-css-extract-plugin
export default {"wrapper":"O_CapsuleLayout_wrapper__tIfKN","title":"O_CapsuleLayout_title__7yUpl","indicators_wrapper":"O_CapsuleLayout_indicators_wrapper__m4i1w"};